<ul class="root" *ngIf="data">
    <li class="root__item" *ngFor="let item of data.issuuItems.value">
        <issuu-item-block [data]="item"></issuu-item-block>
    </li>
</ul>
